import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";

import Color from "@tool/color";
import "./scss/index.scss";
import Title from "@/page/index/component/title";
import CommonTab from "@/page/index/component/common-Tab";
import TimeTab from "@/page/index/component/time-tab";
import moBility, {
  changeTalentActive,
  changeRoleLeftActive,
  changeRoleRightActive,
  changeActiveTime,
  changeActiveCate,
} from "../../store/mobility";
import TalentChart from "./component/talent-chart";
import LeftChart from "./component/left-chart";
import RightChart from "./component/right-chart";
import { isEmpty } from "lodash";
import Empty from "@/component/empty";
import moPortrait from "../../store/portrait";
import moIndex from "@/page/index/store";
interface IProps {}
interface IState {}

// 人力需求
const MobilityOverview = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isMock } = moIndex;
  const {
    yearList,
    activeTime,
    roleLeftActive,
    roleRightActive,
    talentActive,
    cateList,
    activeCate,
    talendList,
    roleList,
  } = moBility;
  const tabList = [
    { code: "inflow", value: "人才流入" },
    { code: "outflow", value: "人才流出" },
  ];

  const roleTabList = [
    {
      value: "职能",
      code: "role",
    },
    {
      value: "行业",
      code: "industry",
    },
  ];

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="mobility-overview-warp">
      <section className="tops-title-warp" id="mobility">
        <Title title="人才流动" subtitle="人才流动概览" />
      </section>
      <p className="sub-titles">所选时间周期下，跳槽到本行业的人才分别来自哪些行业。</p>
      <section className="mobility-warp">
        <section
          className="talent-warp"
          style={{
            backgroundImage: isMock
              ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
              : "",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        >
          <section className="tab">
            <p className="title">
              {talentActive === "inflow" ? "人才流入" : "人才流出"}
            </p>
            <CommonTab
              list={tabList}
              active={talentActive}
              onChange={(val: string) => {
                changeTalentActive(val);
              }}
            />
          </section>
          {!isEmpty(talendList) ? <TalentChart /> : <Empty />}
        </section>
        <section>
          {!isEmpty(cateList) && (
            <section className="mobility-tab">
              <CommonTab
                list={cateList}
                active={activeCate}
                onChange={(val: string) => {
                  changeActiveCate(val);
                }}
              />
            </section>
          )}
        </section>
        <section className="role-group-warp">
          <section
            className="role-warp"
            style={{
              backgroundImage: isMock
                ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
                : "",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
            }}
          >
            <section className="tab">
              <p className="title">职能流入</p>
              <CommonTab
                list={roleTabList}
                active={roleLeftActive}
                onChange={(val: string) => {
                  changeRoleLeftActive(val);
                }}
              />
            </section>
            {!isEmpty(roleList) ? <LeftChart /> : <Empty />}
          </section>
          <section
            className="role-warp"
            style={{
              backgroundImage: isMock
                ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
                : "",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
            }}
          >
            <section className="tab">
              <p className="title">职能流出</p>
              <CommonTab
                list={roleTabList}
                active={roleRightActive}
                onChange={(val: string) => {
                  changeRoleRightActive(val);
                }}
              />
            </section>
            <section>{!isEmpty(roleList) ? <RightChart /> : <Empty />}</section>
          </section>
        </section>
        {!isEmpty(yearList) && (
          <TimeTab
            list={yearList}
            active={activeTime}
            onChange={(val: string) => {
              changeActiveTime(val);
            }}
          />
        )}
      </section>
    </section>
  );
};

export default observer(MobilityOverview);
